import { CollectedItemDetails, MagicCard, RarityType } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { FilterType, PreviewItemFilterOption } from "@ponder-shared/tools/filter/preview-item-filter-option";
import { enumFromStringValue } from "@ponder-shared/utils/general";

export enum MagicCardRarityOption {
    All = "All Rarities",
    Common = "Common",
    Uncommon = "Uncommon",
    Rare = "Rare",
    Mythic = "Mythic",
    Special = "Special"
}

export class MagicCardFilterRarity extends PreviewItemFilterOption {
    private currentChoice: MagicCardRarityOption = MagicCardRarityOption.All;
    private filters = new Map<string, number | undefined>();
    private allValid: boolean = true;
    
    constructor() {
        super("Rarity", FilterType.Select, "", MagicCardRarityOption.All, MagicCardRarityOption.All);
    }

    public prepare(): void {
        this.filters.clear();

        Object.values(MagicCardRarityOption).forEach(o => {
            if (o == MagicCardRarityOption.All) {
                this.filters.set(o, undefined);
            } else {
                this.filters.set(o, 0);
            }
        });
    }

    public track(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): void {
        var key = this.getMatchingOption(magicCard);
        this.filters.set(key, this.filters.get(key)! + 1);
    }

    public updateSelection(selection: string, page: string): boolean {
        var rarityEnum = enumFromStringValue(MagicCardRarityOption, selection);

        if (!rarityEnum || (this.currentChoice == rarityEnum)) {
            return false;
        }

        this.setStoredFilter(selection, page);
        this.currentChoice = rarityEnum;
        this.allValid = rarityEnum == MagicCardRarityOption.All;
        this.wasUpdated = true;

        return true;
    }

    public getFilters(): Map<string, number | undefined> {
        return this.filters;
    }

    public isValid(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): boolean {
        if (this.allValid) {
            return true;
        }

        return this.allValid || (this.currentChoice == this.getMatchingOption(magicCard));
    }

    private getMatchingOption(magicCard: MagicCard): MagicCardRarityOption {
        switch (magicCard.rarity) {
            case RarityType.Special:
                return MagicCardRarityOption.Special;

            case RarityType.Mythic:
                return MagicCardRarityOption.Mythic;

            case RarityType.Rare:
                return MagicCardRarityOption.Rare;

            case RarityType.Uncommon:
                return MagicCardRarityOption.Uncommon;

            case RarityType.Common:
            default:
                return MagicCardRarityOption.Common;
        }
    }

    public sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}